import React from 'react';
import AsyncSelect, {components}from 'react-select';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes,faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { omit, isNull } from 'lodash/fp'

const CustomSelect = styled(AsyncSelect)`
  width:100%;
  margin-right: 1px;
  .css-1p33hnp-placeholder {
    font-size: 13px;
    color: #969CA6;
  }  
  &.is-invalid > div{
  border-color: #dc3545;
}

`;
const OptionDiv = styled.div`
  font-family: Titillium Web;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  height: 27px;
  line-height: 17px;
  color: #27364E;
  text-align: left;
  margin-left: 10px;
  cursor: pointer;
  position: relative;
`;
const MultiContainer = styled.div`
    align-items: center;
    border-radius: 4px;
    background: ${props => (props.selectedColor && props.selectedColor === 'lightBlue') ? '#41B6E6' : props.selectedColor};
    color: #27364E;
    cursor: pointer;
    font-family: Titillium Web;
    font-style: normal;
    justify-content: center;
    padding:4px 5px 6px 5px;    
    font-weight: 600;
    font-size: 11px;
    line-height: 17px;
    margin: 0 0 0 2px !important;
`;
const OptionText = styled.span`
  color: ${props => (props.dropDownColor && props.dropDownColor === 'lightBlue') ? '#41B6E6' : props.dropDownColor};
  position: absolute;
  left: 19px;
`;
export const HorizontalLine = styled.hr`
   height: 1.5px;
   margin-top: 5px;
`;
const AwesomeIcon = styled(FontAwesomeIcon)`
  margin-right: 5px;
  color: ${props => props.selected ? '#FFFFFF' : (props.dropDownColor === 'lightBlue' ? '#41B6E6' : props.dropDownColor)};
  margin-left: ${props => props.selected ? '3px ' : ''}
  `;
const SelectedText = styled.span`
  color: #FFFFFF;
`;


const customStyles = {
    valueContainer: (provided) => ({
        ...provided,
        padding: 0,
    }),
    placeholder:(provided) => ({
        ...provided,
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '10px',
        lineHeight: '12px',
        paddingLeft:'9px',
    }),
    control : (provided) => ({
        ...provided,
        height: '33px !important',
        minHeight: '33px !important',
    }),

    menu: (provided) => ({
        ...provided,
        maxMenuHeight: 162,
        borderBottom: '1px solid #F1F1F1',
    }),
    menuList: (provided) => ({
        ...provided,
        paddingBottom: 0,
        maxHeight: 162,

    }),
    dropdownIndicator: (provided,state) => ({
        ...provided,
        transform: state.selectProps.menuIsOpen && 'rotate(180deg)'
    }),
    indicatorSeparator: (provided, state) => ({
        ...provided,
        width: 0,
    }),

    multiValueRemove: (styles) => ({
            ...styles,
            ':hover': {
                backgroundColor: '',
                color: '',
            }}
    )
};

class TagsSelector extends React.Component {

    onInputChange = (props, { action }) => {
        if (this.props.selectedOption && this.props.selectedOption.length === 1){
            this.selectRef.select.blur();
        }
    };
    state ={
        touched : false,
    }

    render() {
        const { options, selectedOption, handleSelectChange, error, validate,} = this.props;
        const {touched} = this.state;

        let validationClass = '';
        if (!validate) {
            if ((isNull(selectedOption) || !touched) && !error) {
                validationClass = '';
            } else if (error) {
                validationClass = 'is-invalid';
            } else if (selectedOption) {
                validationClass = 'is-valid';
            }
        }
        const customOption = ({ data, innerProps }) => (
            <OptionDiv {...innerProps} >
                { data.fontAwesomeIcon &&
                <span>
                    <AwesomeIcon icon={ data.fontAwesomeIcon } dropDownColor={data.categoryIconColour}/>
                </span>
                }
                <OptionText dropDownColor={data.categoryIconColour}>{ data.tagText }</OptionText>
                <HorizontalLine/>
            </OptionDiv>
        );

        const MultiValue = ({props,data}) => (
            <MultiContainer {...props}  selectedColor = {data.categoryIconColour}>
               <span  {...props}>
                 { data.fontAwesomeIcon &&
                  <span>
                    <AwesomeIcon icon={ data.fontAwesomeIcon } selected/>
                  </span>  }
               <SelectedText>{ data.tagText }</SelectedText>
               </span>
                <span {...props} onClick={() => this.selectRef.select.removeValue(data)} style={{paddingLeft:'5px'}}>
                <FontAwesomeIcon icon={faTimes} style={{color:'#FFFFFF'}}/>
                </span>
            </MultiContainer>
        );

        const DropdownIndicator = (props) => {
            return (
                <components.DropdownIndicator {...props}>
                    <FontAwesomeIcon icon={faAngleDown}/>
                </components.DropdownIndicator>
            );
        };

        return (
            <>
               <CustomSelect
                getOptionLabel={option => option.tagText}
                getOptionValue={option => option.id}
                value={ selectedOption }
                closeMenuOnSelect={false}
                isClearable={false}
                styles={customStyles}
                components={{ Option:customOption , MultiValue, DropdownIndicator}}
                isMulti
                onChange={handleSelectChange}
                options={options}
                placeholder="Choose 1 or 2 tags"
                ref={input => this.selectRef = input }
                onInputChange={this.onInputChange}
                className={`${validationClass}`}
                {...omit(['error', 'className', 'value', 'onBlur'], this.props)}
            />
             </>
        );
    }
}
export default TagsSelector;
